import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogPortal,
  DialogOverlay,
} from "../../../components/ui/Dialog";

interface ExitDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onStillLeave: () => void;
  onStayToContiune: () => void;
}

export default function ExitDialog({
  isOpen,
  onClose,
  onStillLeave,
  onStayToContiune,
}: ExitDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogPortal>
        <DialogOverlay className="fixed inset-0 z-50 bg-[#D3D3D380]" />
        <DialogContent className="fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background px-16 py-8 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg">
          <DialogHeader>
            <div className="flex flex-col items-start text-left">
              <DialogTitle className="text-xl font-bold">
                Reminder Before You Leave
              </DialogTitle>
              <DialogDescription className="sr-only">
                Exit confirmation dialog
              </DialogDescription>
            </div>
          </DialogHeader>

          <div className="flex flex-col items-center space-y-6">
            <p className="text-gray-500 text-left">
              Your current progress will be automatically saved, so nothing will
              be lost. You will see a{" "}
              <span
                style={{
                  color: "var(--color-primary)",
                  borderColor: "var(--color-primary)",
                }}
              >
                temporary report{" "}
              </span>{" "}
              based on your current performance. Are you sure you want to leave
              this page?
            </p>

            {/* Buttons */}
            <div className="flex gap-4 w-full justify-start">
              <button
                onClick={onStillLeave}
                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 font-medium"
              >
                Still Leave
              </button>
              <button
                onClick={onStayToContiune}
                className="px-4 py-2  text-white rounded-md hover:bg-blue-700 font-medium"
                style={{
                  backgroundColor: "var(--color-primary)",
                  borderColor: "var(--color-primary)",
                }}
              >
                Stay to Continue
              </button>
            </div>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
